export function openingLoader() {

  const cookieExists = document.cookie.split('; ').some(row => row.startsWith('animationPlayed='));

  const element = document.querySelector('.farlo-lcc-loader');
  
  if (!cookieExists && element) {

    element.classList.add('farlo-lcc-loader--active');
    
    element.addEventListener('animationend', function() {
      const oneWeek = 60 * 60 * 24 * 7;
      document.cookie = "animationPlayed=true; path=/; max-age=" + oneWeek;
      document.body.classList.remove("show-preloader");
    });

    setTimeout(() => {
      window.addEventListener('resize', () => {
        element.classList.remove('farlo-lcc-loader--active');
      });
    }, 3000);

  } else if (element) {
    document.body.classList.remove("show-preloader");
    element.classList.remove('farlo-lcc-loader--active');
  }
}
